module.exports = __webpack_public_path__ + "static/img/5g (2).eeaa8d23.png";